/** Optional ancestor hook, called once a floating popup has been laid out on each opening. */
export const POPUP_POSITIONED = Symbol("popup-positioned");
